import { Container, Dialog, CircularProgress, Box } from "@mui/material";
// import { ModelModal } from "components/modal/ModelModal";
// import ModelTable from "components/table/ModelTable";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  queryOptionsState,
  selectedButtonState,
  selectedMenuState,
} from "../recoil/index.ts";
import { getInspModels } from "../services/inspModelService.js";
import ModelTable from "../components/inspModel/ModelTable.js";
import { ModelModal } from "../components/inspModel/ModelModal.js";
import CustomButton from "../components/customComponent/CustomButton.tsx";
import { SearchComponent } from "../components/SearchComponent.tsx";

export default function InspModelPage() {
  const setSelectedMenu = useSetRecoilState(selectedMenuState);
  const setSelectedButton = useSetRecoilState(selectedButtonState);
  const [openModal, setOpenModal] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [receivedData, setReceivedData] = useState([]);
  const [queryOption, setQueryOption] = useRecoilState(queryOptionsState);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedModelInfo, setSelectedModelInfo] = useState(null);
  const [keyword, setKeyword] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedMenu(t("InspectionModel"));
    setSelectedButton(t("InspectionModel"));
  }, []);

  const fetchDatas = async () => {
    try {
      setIsLoading(true);
      const response = await getInspModels({
        page: currentPage,
        size: 20,
        keyword,
      });
      setReceivedData(response.data.contents);
      setCount(response.data.total_count);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (keyword === null) {
      fetchDatas();
    }
  }, [currentPage, keyword]);

  useEffect(() => {
    if (keyword !== null) {
      fetchDatas();
    }
  }, [currentPage, keyword]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress style={{ color: "var(--text-color)" }} />
      </div>
    );
  }

  return (
    <>
      <div className="p-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">검사 모델</h1>
        </div>
      </div>
      <Container
        className="middle-container"
        style={{ background: "var(--row-color)" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "42px",
          }}
        >
          <CustomButton
            id="new-insp-model-btn"
            text={t("CreateInspModel")}
            variant="outlined"
            // onClick={() => {
            //   navigate("/main/training/create");
            // }}
            onClick={() => {
              navigate("/insp-model/create");
            }}
            // onClick={handleOpenModal}
          />
          <SearchComponent
            menu="insp_model"
            setPage={setCurrentPage}
            keyword={keyword}
            setKeyword={setKeyword}
          />
        </Box>
        <ModelTable
          setCount={setCount}
          setOpenModal={setOpenModal}
          receivedData={receivedData}
          setReceivedData={setReceivedData}
          total={count}
          currentPage={currentPage}
          setPage={setCurrentPage}
          setSelectedModelInfo={setSelectedModelInfo}
        />
      </Container>
      {openModal && (
        <Dialog
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            // navigate("/model");
          }}
          sx={{
            "& .MuiPaper-root": {
              maxWidth: "700px",
            },
          }}
        >
          <ModelModal setOpenModal={setOpenModal} row={selectedModelInfo} />
        </Dialog>
      )}
    </>
  );
}
